import React, { useEffect, useState } from "react";
import {
  PlusOutlined,
} from "@ant-design/icons";
import {
  Button,
  Input,
  Select,
  Form,
  Upload,
  Modal,
  Alert,
} from "antd";

import styles from "./style.module.scss";
import {
  addCertificate,
  getRestaurants,
  updateCertificate,
  uploadPhoto,
} from "../../../services/CertificateService";

const { Option } = Select;

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

const AddCertificate = ({
  modalOpen,
  onAddorUpdate,
  isEdit,
  selectedCertificate,
  closeModal,
}) => {
  const [restaurants, setRestaurants] = useState([]);
  const [previewImage, setPreviewImage] = useState("");
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewTitle, setPreviewTitle] = useState("");
  const [fileList, setFileList] = useState(
    selectedCertificate?.photo_url
      ? [
          {
            uid: 1,
            name: selectedCertificate?.name,
            status: "done",
            url: selectedCertificate?.photo_url,
          },
        ]
      : []
  );
  const [formError, setFormError] = useState("");
  const [file, setFile] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [selectedRestaurantId, setSelectedRestaurantId] = useState(
    selectedCertificate?.restaurant_id
  );
  const [certificateDescription, setCertificateDescription] = useState(
    selectedCertificate?.name
  );

  useEffect(() => {
    try {
      getRestaurants().then((res) => setRestaurants(res.restaurants));
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffect(() => {
    if (isEdit) {
      setFileList(
        selectedCertificate?.photo_url
          ? [
              {
                uid: 1,
                name: selectedCertificate?.name,
                status: "done",
                url: selectedCertificate?.photo_url,
              },
            ]
          : []
      );

      setSelectedRestaurantId(selectedCertificate?.restaurant_id);
      setCertificateDescription(selectedCertificate?.name);
    }
  }, [isEdit, selectedCertificate]);

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewVisible(true);
    setPreviewTitle(
      file.name || file.url.substring(file.url.lastIndexOf("/") + 1)
    );
  };

  const handleCancel = () => setPreviewVisible(false);

  const handleChange = ({ fileList }) => setFileList(fileList);

  const saveCertificate = async () => {
    if (!selectedCertificate && (!true || !selectedRestaurantId)) {
      return setFormError("Please ensure all fields are filled out.");
    }
    setIsSaving(true);
    try {
      let photoUrl = selectedCertificate?.photo_url;
      if (file && selectedCertificate?.photo_url) {
        // TODO: delete old photo
      }
      if (file) {
        const formdata = new FormData();
        formdata.append("file", file);
        photoUrl = await uploadPhoto(formdata);
      }
      if (selectedCertificate?.id) {
        // edit
        const payload = {
          restaurant_id: selectedCertificate.restaurant_id,
          name: certificateDescription,
          photo_url: photoUrl?.url,
        };
        const newCertificate = await updateCertificate(
          selectedCertificate.id,
          payload
        );
        const getUpdatedList = (list) =>
          list.reduce((reduced, c) => {
            if (c.id === selectedCertificate.id) {
              return reduced.concat(newCertificate);
            }
            return reduced.concat(c);
          }, []);
      } else {
        // Add
        const payload = {
          name: certificateDescription,
          photo_url: file ? photoUrl?.url : "",
          restaurant_id: selectedRestaurantId,
        };
        await addCertificate(payload);
      }
    } catch (error) {
      console.error(error);
      setFormError("Couldn't upload image. Please try again later.");
    } finally {
        onAddorUpdate();
        setIsSaving(false);
    }
   
  };

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  return (
    <Modal
      title="Add New Certification"
      onCancel={() => {
        setFormError("");
        closeModal()
      }}
      footer={null}
      open={modalOpen}
    >
      {formError && (
        <Alert message={formError} type="error" style={{ marginBottom: 24 }} />
      )}
      <Form layout="vertical">
        <div>
          <div className="ant-col ant-form-item-label">
            <label htmlFor="Restaurant" title="Restaurant">
              Restaurant
            </label>
          </div>
          <Select
            id="Restaurant"
            className={styles.wfull}
            placeholder="Please choose restaurant"
            value={selectedRestaurantId}
            onChange={(val) => setSelectedRestaurantId(val)}
          >
            {restaurants.map((res) => (
              <Option key={res.id} value={res.id}>
                {res.name}
              </Option>
            ))}
          </Select>
        </div>
        <div style={{ marginBottom: 24 }}>
          <div
            className="ant-col ant-form-item-label"
            style={{ marginTop: 24 }}
          >
            <label htmlFor="Description" title="Description">
              Description
            </label>
          </div>
          <Input
            rows={4}
            placeholder="Please enter description"
            value={certificateDescription}
            onChange={(e) => setCertificateDescription(e.target.value)}
          />
        </div>

        <Upload
          listType="picture-card"
          fileList={fileList}
          onPreview={handlePreview}
          onChange={handleChange}
          maxCount={1}
          beforeUpload={(file) => {
            setFile(file);
            return false;
          }}
        >
          {fileList.length >= 8 ? null : uploadButton}
        </Upload>
        <Button
          loading={isSaving}
          type="primary"
          onClick={saveCertificate}
          className={styles.mt2}
        >
          Save
        </Button>
      </Form>
      <Modal
        visible={previewVisible}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}
      >
        <img alt="" style={{ width: "100%" }} src={previewImage} />
      </Modal>
    </Modal>
  );
};

export default AddCertificate;
